import { createElement, Component, createContext } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var Page = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Page, _React$Component);

  function Page() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Page.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        page = _this$props.page,
        onClick = _this$props.onClick,
        selected = _this$props.selected,
        className = _this$props.className,
        href = _this$props.href;
    return createElement("li", {
      title: "\u7B2C" + page + "\u9875",
      className: cls(className, {
        active: selected
      })
    }, createElement("a", {
      href: href,
      onClick: onClick
    }, page));
  };

  return Page;
}(Component);

var PagerConfig = /*#__PURE__*/createContext({});

var Pager = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Pager, _React$Component);

  function Pager() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      current: 1,
      jumpPage: ''
    };

    _this.createHref = function (page) {
      // const { current } = this.state;
      var _this$getAssignProps = _this.getAssignProps(),
          pageCount = _this$getAssignProps.pageCount,
          pageRange = _this$getAssignProps.pageRange,
          hrefCreator = _this$getAssignProps.hrefCreator;

      return hrefCreator ? hrefCreator(page, pageCount, pageRange) : undefined;
    };

    _this.onJumpInputChange = function (e) {
      var _this$getAssignProps2 = _this.getAssignProps(),
          pageCount = _this$getAssignProps2.pageCount;

      var value = e.target.value;

      var _int = Number(value);

      if (_int === 0 || Number.isNaN(_int)) return _this.setState({
        jumpPage: ''
      });

      _this.setState({
        jumpPage: Math.max(1, Math.min(_int, pageCount))
      });
    };

    _this.onJumpBtnClick = function (e) {
      e.preventDefault();
      var jumpPage = _this.state.jumpPage;

      if (typeof jumpPage === 'number') {
        _this.props.onPageChange(jumpPage);

        _this.setState({
          jumpPage: ''
        });
      }
    };

    _this.onPageClick = function (page) {
      _this.setState({
        current: page
      });

      _this.props.onPageChange(page);
    };

    _this.onPrevPageClick = function (e) {
      e.preventDefault();
      var current = _this.state.current;
      if (current === 1) return;

      _this.setState(function (prevState) {
        return {
          current: prevState.current - 1
        };
      });

      _this.props.onPageChange(current - 1);
    };

    _this.onNextPageClick = function (e) {
      e.preventDefault();
      var current = _this.state.current;
      var pageCount = _this.props.pageCount;
      if (current >= pageCount) return;

      _this.setState(function (prevState) {
        return {
          current: prevState.current + 1
        };
      });

      _this.props.onPageChange(current + 1);
    };

    return _this;
  }

  Pager.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    if (typeof props.forcePage !== 'undefined') {
      return {
        current: props.forcePage
      };
    }

    return null;
  };

  var _proto = Pager.prototype;

  _proto.getAssignProps = function getAssignProps() {
    return Object.assign({}, this.props, this.context);
  };

  _proto.getPageNode = function getPageNode(page) {
    var _this2 = this;

    var current = this.state.current;

    var _this$getAssignProps3 = this.getAssignProps(),
        pageClassName = _this$getAssignProps3.pageClassName;

    return createElement(Page, {
      href: this.createHref(page),
      className: pageClassName,
      key: page,
      selected: current === page,
      onClick: function onClick(e) {
        e.preventDefault();

        _this2.onPageClick(page);
      },
      page: page
    });
  };

  _proto.pagination = function pagination() {
    var items = [];

    var _this$getAssignProps4 = this.getAssignProps(),
        pageCount = _this$getAssignProps4.pageCount,
        pageRange = _this$getAssignProps4.pageRange;

    var current = this.state.current;

    if (pageCount <= pageRange) {
      for (var i = 0; i < pageCount; i++) {
        items.push(this.getPageNode(i + 1));
      }
    } else {
      // nice
      //  pageRange = {current-2 current-1 current current+1 current+1  }
      var half = Math.floor(pageRange / 2);
      var start = current - half + 1 - pageRange % 2;
      var end = current + half;

      if (current <= pageRange - half) {
        start = 1;
        end = pageRange;
      }

      if (current >= pageCount - half) {
        end = pageCount;
        start = pageCount - pageRange + 1;
      }

      var itPage = start;

      while (itPage <= end) {
        items.push(this.getPageNode(itPage));
        itPage++;
      }
    }

    return items;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$getAssignProps5 = this.getAssignProps(),
        firstLabel = _this$getAssignProps5.firstLabel,
        lastLabel = _this$getAssignProps5.lastLabel,
        showFirst = _this$getAssignProps5.showFirst,
        showLast = _this$getAssignProps5.showLast,
        pagerClassName = _this$getAssignProps5.pagerClassName,
        prevLabel = _this$getAssignProps5.prevLabel,
        nextLabel = _this$getAssignProps5.nextLabel,
        pageCount = _this$getAssignProps5.pageCount,
        hrefCreator = _this$getAssignProps5.hrefCreator,
        pageRange = _this$getAssignProps5.pageRange,
        containerClassName = _this$getAssignProps5.containerClassName,
        showTotal = _this$getAssignProps5.showTotal,
        showJump = _this$getAssignProps5.showJump,
        autoHide = _this$getAssignProps5.autoHide,
        showTotalRecords = _this$getAssignProps5.showTotalRecords,
        totalRecords = _this$getAssignProps5.totalRecords;

    if (pageCount <= 1 && autoHide) return null;
    var _this$state = this.state,
        current = _this$state.current,
        jumpPage = _this$state.jumpPage;
    var showRightMore = pageCount > pageRange && current < Math.ceil(pageCount - pageRange / 2);
    var showLeftMore = pageCount > pageRange && current > Math.ceil(pageRange / 2);
    return createElement("div", {
      className: containerClassName
    }, createElement("ul", {
      className: pagerClassName
    }, showFirst && createElement("li", {
      className: cls('first-page', 'page-btn', {
        disable: pageCount === 1
      })
    }, createElement("a", {
      href: hrefCreator ? hrefCreator(1, pageCount, pageRange) : undefined,
      onClick: function onClick(e) {
        e.preventDefault();

        _this3.onPageClick(1);
      }
    }, firstLabel)), createElement("li", {
      className: cls('prev-page', 'page-btn', {
        disable: current === 1
      })
    }, createElement("a", {
      href: hrefCreator && current > 1 ? hrefCreator(current - 1, pageCount, pageRange) : undefined,
      onClick: this.onPrevPageClick
    }, prevLabel)), showLeftMore && createElement("li", {
      className: "more-page page-btn disable"
    }, createElement("a", null, "...")), this.pagination(), showRightMore && createElement("li", {
      className: "more-page page-btn disable"
    }, createElement("a", null, "...")), createElement("li", {
      className: cls('next-page', 'page-btn', {
        disable: current >= pageCount
      })
    }, createElement("a", {
      href: hrefCreator && current < pageCount ? hrefCreator(current + 1, pageCount, pageRange) : undefined,
      onClick: this.onNextPageClick
    }, nextLabel)), showLast && createElement("li", {
      className: cls('last-page', 'page-btn', {
        disable: pageCount === 1
      })
    }, createElement("a", {
      href: hrefCreator ? hrefCreator(pageCount, pageCount, pageRange) : undefined,
      onClick: function onClick(e) {
        e.preventDefault();

        _this3.onPageClick(pageCount);
      }
    }, lastLabel))), showTotal && createElement("span", {
      className: "page-total"
    }, "\u603B\u9875\u6570:", pageCount), showTotalRecords && createElement("span", {
      className: "page-total-records"
    }, totalRecords), showJump && createElement("div", {
      className: "page-jump"
    }, createElement("input", {
      value: jumpPage,
      onChange: this.onJumpInputChange,
      type: "text"
    }), createElement("button", {
      onClick: this.onJumpBtnClick,
      type: "button"
    }, "\u786E\u5B9A")));
  };

  return Pager;
}(Component);
Pager.contextType = PagerConfig;
Pager.defaultProps = {
  prevLabel: '上一页',
  nextLabel: '下一页',
  pagerClassName: 'mp-pages',
  firstLabel: '首页',
  lastLabel: '末页',
  showFirst: true,
  showLast: true,
  pageClassName: 'page-item',
  containerClassName: 'mp-pager',
  showTotal: true,
  showTotalRecords: false,
  showJump: true,
  pageRange: 5,
  autoHide: true
};
Pager.propTypes = {
  pageCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

export { Pager, PagerConfig };
//# sourceMappingURL=pager.esm.js.map
